<div class="bulk-orders-container fade-in-up">
  <input type="file" #fileInput (change)="onFileSelected($event)" accept=".xlsx, .xls, .csv" style="display: none">
  <div class="page-header">
    <div class="header-row">
      <div></div><!-- spacer to push actions to the right -->
      <div class="page-actions">
        <button class="btn btn-secondary" (click)="openPortalSheet()" [disabled]="isAccessingSheet">
          <i class="fa fa-spinner fa-spin" *ngIf="isAccessingSheet" style="margin-right: 8px;"></i>
          <svg *ngIf="!isAccessingSheet" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M3 10h18M3 6h18M3 14h18M3 18h18" />
          </svg>
          <span *ngIf="!isAccessingSheet">Open Sheet</span>
          <span *ngIf="isAccessingSheet">Opening...</span>
        </button>

        <button class="btn btn-secondary" (click)="importSheet()">
          <svg fill="none" stroke="currentColor" stroke-width="2" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" d="M3 16.5v2.25A2.25 2.25 0 005.25 21h13.5A2.25 2.25 0 0021 18.75V16.5M16.5 12 12 16.5m0 0L7.5 12m4.5 4.5V3" />
          </svg>
          Import Sheet
        </button>

        <button class="btn btn-secondary" (click)="saveDraftBtn()" [disabled]="isSavingDraft">
          <i class="fa fa-spinner fa-spin" *ngIf="isSavingDraft" style="margin-right: 8px;"></i>
          <svg *ngIf="!isSavingDraft" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
              d="M8 7H5a2 2 0 00-2 2v9a2 2 0 002 2h14a2 2 0 002-2V9a2 2 0 00-2-2h-3m-1 4l-3 3m0 0l-3-3m3 3V4" />
          </svg>
          <span *ngIf="!isSavingDraft">Save Draft</span>
          <span *ngIf="isSavingDraft">Saving...</span>
        </button>

        <button class="btn btn-outline" (click)="addRows()">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
          </svg>
          Add Rows
        </button>

        <button *ngIf="hasActiveRows" class="btn btn-outline btn-clear" (click)="clearAllRows()" [disabled]="isLoading">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" />
          </svg>
          Clear All
        </button>

        <div class="nav-arrows">
          <button class="nav-arrow" (click)="scrollTable('left')" (dblclick)="scrollToExtreme('left')"
            title="Scroll Left (Double-click to far left)">
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
            </svg>
          </button>
          <button class="nav-arrow" (click)="scrollTable('right')" (dblclick)="scrollToExtreme('right')"
            title="Scroll Right (Double-click to far right)">
            <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
            </svg>
          </button>
        </div>
      </div>
    </div>
  </div>

  <!-- Bulk Orders Table -->
  <div class="table-wrapper">
    <div *ngIf="rows.length > 0 || isLoading" class="table-scroll-container" id="tableScrollContainer">
      <table class="bulk-table">
        <thead>
          <tr>
            <th class="col-row">Row</th>
            <th class="col-order-no required">Order No/Pickup No <span class="required">*</span></th>
            <th class="col-warehouse required">Order Type <span class="required">*</span></th>
            <th class="col-company-name required">Company Name <span class="required">*</span></th>
            <th class="col-company-address required">Company Address <span class="required">*</span></th>
            <th class="col-contact-name">Contact Name <span class="required">*</span></th>
            <th class="col-country-code">Country Code <span class="required">*</span></th>
            <th class="col-phone">Phone Number <span class="required">*</span></th>
            <th class="col-alt-phone">Alternate Phone Number</th>
            <th class="col-email">Email</th>
            <th class="col-delivery-date required">Delivery Date <span class="required">*</span></th>
            <th class="col-pickup-date required">Pickup Date <span class="required">*</span></th>
            <th class="col-delivery-time">Delivery Time</th>
            <th class="col-pickup-time">Pickup Time</th>
            <th class="col-service-time required">Service Time</th>
            <th class="col-driver-name">Driver Name</th>
            <th class="col-sign-req required">Sign Req <span class="required">*</span></th>
            <th class="col-delpju required">Del/PU <span class="required">*</span></th>
            <th class="col-note">Note</th>
            <th class="col-actions">Actions</th>
          </tr>
        </thead>
        <tbody *ngIf="!isLoading">
          <tr *ngFor="let row of rows; trackBy: trackByRowNumber" app-bulk-order-row [row]="row"
            [warehouseOptions]="warehouseOptions" [countryCodeOptions]="countryCodeOptions"
            [serviceTimeOptions]="serviceTimeOptions" [driverOptions]="driverOptions" [yesNoOptions]="yesNoOptions"
            [delpuOptions]="Delpu" [allRows]="rows" [companies]="initialCompanies" [addresses]="initialAddresses"
            [minDate]="minDate" [defaultCountryCode]="defaultCountryCode" (rowFocus)="onRowFocus($event)"
            (delete)="deleteRow($event.rowNumber, $event)"
            (companySelected)="onCompanySelection($event.row.companyName, $event.row.companyAddress, $event.row.rowNumber)"
            (addressSelected)="onCompanySelection($event.row.companyName, $event.row.companyAddress, $event.row.rowNumber)"
            (openAddressDialog)="openDialog('0ms', '0ms', $event)"
            (companyAdded)="onCompanyAdded($event)">
          </tr>
        </tbody>

        <!-- Skeleton Rows -->
        <tbody *ngIf="isLoading">

          <tr *ngFor="let item of [1,2,3,4,5,6,7,8,9,10]">
            <td class="col-row">
              <div class="skeleton-line centered" style="width: 25px;"></div>
            </td>
            <td>
              <div class="skeleton-line full"></div>
            </td>
            <td>
              <div class="skeleton-line full"></div>
            </td>
            <td>
              <div class="skeleton-line full"></div>
            </td>
            <td>
              <div class="skeleton-line full"></div>
            </td>
            <td>
              <div class="skeleton-line full"></div>
            </td>
            <td>
              <div class="skeleton-line centered" style="width: 40px;"></div>
            </td>
            <td>
              <div class="skeleton-line full"></div>
            </td>
            <td>
              <div class="skeleton-line full"></div>
            </td>
            <td>
              <div class="skeleton-line full"></div>
            </td>
            <td>
              <div class="skeleton-line full"></div>
            </td>
            <td>
              <div class="skeleton-line full"></div>
            </td>
            <td>
              <div class="skeleton-line full"></div>
            </td>
            <td>
              <div class="skeleton-line full"></div>
            </td>
            <td>
              <div class="skeleton-line full"></div>
            </td>
            <td>
              <div class="skeleton-line full"></div>
            </td>
            <td>
              <div class="skeleton-line centered" style="width: 60px;"></div>
            </td>
            <td>
              <div class="skeleton-line centered" style="width: 60px;"></div>
            </td>
            <td>
              <div class="skeleton-line full"></div>
            </td>
            <td>
              <div class="skeleton-action"></div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Empty State for 0 Orders -->
    <div class="empty-state" *ngIf="rows.length === 0 && !isLoading">
      <div class="empty-state-icon">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" d="M19.5 14.25v-2.625a3.375 3.375 0 00-3.375-3.375h-1.5A1.125 1.125 0 0113.5 7.125v-1.5a3.375 3.375 0 00-3.375-3.375H8.25m0 12.75h7.5m-7.5 3H12M10.5 2.25H5.625c-.621 0-1.125.504-1.125 1.125v17.25c0 .621.504 1.125 1.125 1.125h12.75c.621 0 1.125-.504 1.125-1.125V11.25a9 9 0 00-9-9z" />
        </svg>
      </div>
      <h3 class="empty-state-title">No Orders Found</h3>
      <p class="empty-state-subtitle">The imported sheet does not contain any orders, or the table is empty.</p>
      <button class="btn btn-secondary" (click)="resetToEmptyRows()" style="margin-top: 24px;">
        <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6" />
        </svg>
        Reset to Blank Grid
      </button>
    </div>
  </div>

  <!-- Footer Actions -->
  <div class="footer-actions">
    <div class="footer-left">
      <div class="nav-arrows">
        <button class="nav-arrow" (click)="scrollTable('left')" (dblclick)="scrollToExtreme('left')"
          title="Scroll Left (Double-click to far left)">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 19l-7-7 7-7" />
          </svg>
        </button>
        <button class="nav-arrow" (click)="scrollTable('right')" (dblclick)="scrollToExtreme('right')"
          title="Scroll Right (Double-click to far right)">
          <svg fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 5l7 7-7 7" />
          </svg>
        </button>
      </div>
    </div>

    <div class="footer-right">
      <button class="btn btn-cancel" (click)="goBack()">
        Cancel
      </button>
      <button class="btn btn-primary" (click)="addOrder()" [disabled]="isAddingOrder">
        <i class="fa fa-spinner fa-spin" *ngIf="isAddingOrder" style="margin-right: 8px;"></i>
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor"
          *ngIf="!isAddingOrder">
          <path stroke-linecap="round" stroke-linejoin="round" d="M12 4.5v15m7.5-7.5h-15" />
        </svg>
        <span *ngIf="!isAddingOrder">Add Order</span>
        <span *ngIf="isAddingOrder">Adding...</span>
      </button>
    </div>
  </div>
</div>